import { render } from "./inputModal.vue?vue&type=template&id=4f82ea58&scoped=true"
import script from "./inputModal.vue?vue&type=script&lang=js"
export * from "./inputModal.vue?vue&type=script&lang=js"

import "./inputModal.vue?vue&type=style&index=0&id=4f82ea58&scoped=true&lang=less"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f82ea58"]])

export default __exports__